<img src="https://www.gravatar.com/avatar/{{ hash }}" />
